import { Link as ReactRouterLink, LinkProps as ReactLinkProps } from 'react-router-dom';

import type { LessModule } from '@omq/types';
import * as React from 'react';

// type of component
type LinkProps = ReactLinkProps &
  React.RefAttributes<HTMLAnchorElement> & {
    style?: LessModule;
  };

//Wrapper component for react router link component
export function Link({ style = {}, ...props }: LinkProps): JSX.Element {
  return (
    <ReactRouterLink
      {...props}
      style={{
        textDecoration: 'none',
        ...style,
      }}
    />
  );
}
